import { useForm, zodResolver } from '@mantine/form';
import { mergeWith } from 'lodash';

import { TSDData, TSDViewPNDataFormValues, TSDViewPNDataSchema } from '@e-origin/contracts';

import { useUpdateTSD } from '@hooks/tsd';

interface UseTsdViewPNDataFormInitializerProps {
  tsd: TSDData;
}

export const useTsdViewPNDataFormInitializer = ({ tsd }: UseTsdViewPNDataFormInitializerProps) => {
  const updateTsdMutation = useUpdateTSD();

  const buildFormValues = (t: TSDData): TSDViewPNDataFormValues => ({
    generalInfo: {
      dateAndTimeOfPresentationOfTheGoods: t.generalInfo?.dateAndTimeOfPresentationOfTheGoods
        ? new Date(t.generalInfo.dateAndTimeOfPresentationOfTheGoods)
        : null,
    },
    customsOfficeOfPresentation: {
      referenceNumber: t.customsOfficeOfPresentation?.referenceNumber ?? '',
    },

    personPresentingTheGoods: {
      identificationNumber: t.personPresentingTheGoods?.identificationNumber ?? '',
      name: t.personPresentingTheGoods?.name ?? '',
      address: {
        streetAndNumber: t.personPresentingTheGoods?.address?.streetAndNumber ?? '',
        country: t.personPresentingTheGoods?.address?.country ?? '',
        postcode: t.personPresentingTheGoods?.address?.postcode ?? '',
        city: t.personPresentingTheGoods?.address?.city ?? '',
      },
      communication: {
        phoneNumber: t.personPresentingTheGoods?.communication?.phoneNumber ?? '',
        eMailAddress: t.personPresentingTheGoods?.communication?.eMailAddress ?? '',
      },
    },

    carrier: {
      name: t.carrier?.name ?? '',
      identificationNumber: t.carrier?.identificationNumber ?? '',
    },
  });

  const form = useForm<TSDViewPNDataFormValues>({
    initialValues: buildFormValues(tsd),
    validate: zodResolver(TSDViewPNDataSchema),
    validateInputOnBlur: true,
  });

  const onSubmit = async (values: TSDViewPNDataFormValues) => {
    updateTsdMutation.mutate({
      tsd: mergeWith(
        { _id: tsd._id, name: tsd.name },
        {
          customer: tsd.customer,
          generalInfo: {
            ...tsd.generalInfo,
            dateAndTimeOfPresentationOfTheGoods: values.generalInfo?.dateAndTimeOfPresentationOfTheGoods
              ? values.generalInfo.dateAndTimeOfPresentationOfTheGoods.toISOString()
              : undefined,
          },
          customsOfficeOfPresentation: values.customsOfficeOfPresentation,
          personPresentingTheGoods: values.personPresentingTheGoods,
          carrier: values.carrier,
        },
      ),
      refreshCustomerData: false,
    });
  };

  return { form, onSubmit, buildFormValues };
};
